<template>
  <v-container class="fill-height">
    <v-overlay v-model="nfcScanning" opacity="0.9">
      <v-container>
        <h2>Bitte die NFC Karte oder den Chip zum Lesegerät halten</h2>
        <v-row align="center">
          <v-col align="center">
            <v-progress-circular
              indeterminate
              color="white"
              size="100"
              width="3"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col align="center">
            <v-btn color="error" @click="stopNFCscanning">Abbrechen</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Mitarbeiter bearbeiten</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form name="userform" @submit.prevent="save" v-model="formValid">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="3">
                    <v-switch
                      v-model="user.active"
                      label="Mitarbeiter aktiv"
                      color="success"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-switch
                      v-if="!user._id"
                      @change="
                        user.sendActivationLink ? (user.password = '') : null
                      "
                      v-model="user.sendActivationLink"
                      label="Aktivierungslink senden"
                      color="success"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field
                      label="Personalnr"
                      name="persnr"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.persnr"
                    />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      label="Anrede"
                      name="anrede"
                      type="text"
                      color="purple"
                      :items="salutationItems"
                      :clearable="true"
                      v-model="user.salutation"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Vorname"
                      name="firstname"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.firstname"
                      required
                      :rules="requiredRule"
                    />
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Nachname"
                      name="lastname"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.lastname"
                      required
                      :rules="requiredRule"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Email"
                      name="email"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.email"
                      required
                      :rules="emailRules"
                    />
                  </v-col>
                  <v-col cols="12" xs="12" sm="6">
                    <v-text-field
                      label="Telefon"
                      name="telefon"
                      type="text"
                      color="purple"
                      :clearable="true"
                      v-model="user.telefon"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="12">
                    <v-text-field
                      :disabled="user.sendActivationLink"
                      label="Passwort"
                      name="password"
                      type="password"
                      color="purple"
                      :clearable="true"
                      v-model="user.password"
                      v-bind:required="
                        user._id == null && !user.sendActivationLink
                          ? 'required'
                          : ''
                      "
                      :rules="
                        user._id == null && !user.sendActivationLink
                          ? requiredRule
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="dataReady">
                  <v-col sm="6">
                    <v-select
                      label="Abteilung"
                      name="abteilung"
                      :items="abteilungen"
                      color="purple"
                      :clearable="false"
                      v-model="user.department"
                      required
                      :rules="requiredRule"
                    />
                  </v-col>
                  <v-col sm="6">
                    <v-select
                      label="Rolle"
                      name="role"
                      :items="roleItems"
                      color="purple"
                      :clearable="true"
                      v-model="user.role"
                      required
                      :rules="requiredRule"
                    />
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-text-field
                      filled
                      dense
                      label="NFC Chip"
                      name="nfc-chip"
                      type="text"
                      color="purple"
                      v-model="user.nfcCard"
                      persistent-hint
                      hint="Code des NFC Chips der dem Mitarbeiter zugewiesen wird"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-btn color="primary" v-if="!user.nfcCard" @click="scanNFC"
                      ><v-icon class="mr-2">mdi-key</v-icon> Chip
                      einlesen</v-btn
                    >

                    <v-btn color="warning" v-if="user.nfcCard" @click="clearNFC"
                      ><v-icon class="mr-2">mdi-close</v-icon> Chip
                      leeren</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-switch
                      v-if="isCustomerAdmin"
                      color="green"
                      v-model="user.canOrderGrossbestellung"
                      label="Darf Großbestellungen bestellen"
                      persistent-hint
                      hint="Kann für alle Gerichte eine Großbestellung für die Firma durchführen"
                    />
                  </v-col>
                </v-row>

                <v-divider class="mt-8" />
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :to="{ path: '/mitarbeiter' }"
              color="error"
              type="button"
              name="cancel"
              >Abbrechen</v-btn
            >
            <v-spacer />
            <v-btn
              @click="save"
              color="success"
              name="submit"
              type="submit"
              :disabled="!formValid"
              >Speichern</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserService from "@/services/UserService.js";
import CustomerService from "@/services/CustomerService.js";

export default {
  name: "EmployeeUserForm",
  components: {},
  props: [],
  data: () => ({
    customer: null,
    dataReady: false,
    nfcScanning: false,
    user: {
      persnr: "",
      salutation: "",
      firstname: "",
      lastname: "",
      telefon: "",
      email: "",
      password: "",
      department: "default",
      _id: null,
      active: true,
      role: "customer",
      canOrderGrossgebinde: false,
      canOrderGrossbestellung: false,
      sendActivationLink: false,
      nfcCard: null,
    },

    salutationItems: ["Herr", "Frau"],

    roleItems: [
      { text: "Admin User", value: "customer-admin" },
      { text: "Mitarbeiter User", value: "customer" },
    ],
    requiredRule: [(value) => !!value || "Dieses Feld wird benötigt!"],
    emailRules: [
      (v) => !!v || "E-mail wird benötigt!",
      (v) =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail must be valid",
    ],
    formValid: false,
  }),
  computed: {
    abteilungen() {
      let list = [];
      if (this.customer) {
        for (let item of this.customer.essenskosten) {
          list.push(item.name);
        }
      }
      return list;
    },
    User() {
      return this.$store.getters["user/getUser"];
    },
    isCustomerAdmin() {
      return (
        this.user.role ===
        this.$store.getters["user/userRoles"].userRole.CustomerAdmin
      );
    },
  },
  methods: {
    checkAccess(role) {
      if (!this.user) {
        return false;
      }
      if (
        this.user.role ===
        this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (this.user.role === role) {
        return true;
      } else {
        return false;
      }
    },
    clearNFC() {
      this.user.nfcCard = null;
    },
    scanNFC() {
      // Add barcode scan listener and pass the callback function
      this.$barcodeScanner.init(this.onNFCscanned);
      this.nfcScanning = true;
    },
    stopNFCscanning() {
      this.nfcScanning = false;
      this.$barcodeScanner.destroy();
    },
    onNFCscanned(code) {
      this.user.nfcCard = code;
      this.stopNFCscanning();
    },

    save() {
      if (
        (this.customer && !this.customer.grossgebinde) ||
        (this.customer && this.customer.grossgebinde && !this.isCustomerAdmin)
      ) {
        this.user.canOrderGrossgebinde = false;
      }

      //set customerId
      this.user.customerId = this.$store.getters["user/getUser"].customerId;
      UserService.saveUser({
        id: this.user._id,
        data: this.user,
      })
        .then(() => {
          //if success redirect to list
          this.$router.push({ name: "mitarbeiter" });
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Mitarbeiter gespeichert",
            text: "Mitarbeiter erfolgreich gespeichert",
          });
        })
        .catch((error) => {
          //on error alert error
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message,
          });
        });
    },
  },
  created() {
    const id = this.$route.params.id;
    let vm = this;
    if (id) {
      this.$store.commit("SET_APP_LOADING", true);
      UserService.fetch(id)
        .then((result) => {
          this.user = result.data.data;
          this.user.password = "";
          return CustomerService.get(this.user.customerId);
        })
        .then((result) => {
          vm.customer = result.data.data;
        })
        .catch((error) => {
          console.log(error);
          if (error && error.response && error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
          this.dataReady = true;
        });
    } else {
      CustomerService.get(this.User.customerId)

        .then((result) => {
          console.log(result);
          vm.customer = result.data.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
          this.dataReady = true;
        });
    }
  },
};
</script>
